import { IpcService } from 'src/app/services/ipc.service';
import { InfoBoxComponent } from './components/info-box/info-box.component';
import { ExerciseService } from 'src/app/services/exercise.service';
import { ETypeUser } from './enums/type-user.enum';
import { AuthWincoService } from 'src/app/services/auth.service';
import { ETypeFooter } from './enums/type-footer.enum';
import { Component, ElementRef, HostListener, ViewChild, ViewChildren, QueryList, NgZone, ChangeDetectorRef } from '@angular/core';
import { ResolveEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { ElectronService } from 'ngx-electron';
import { EViewerAside } from './enums/viewer-aside.enum';
import { BestExerciseDetailComponent } from './components/best-exercise-detail/best-exercise-detail.component';
import { CameraService } from './services/camera.service';
import { ECamera } from './enums/camera.enum';
import { VideoService } from './services/video.service';
import { HttpClientService } from './services/http-client.service';
import { CrudManagerService } from 'crud-manager';
import { DialogBoxData, DialogBoxService, DialogBoxType } from 'dialog-box';
import { VersionBoxService } from 'version-box';
import { Language } from 'language-tab';
import { LanguageService } from './services/language.service';
import { EventManagerService } from 'event-manager';
import { WincoEvents } from './enums/winco-events..enum';
import { WincoUser } from './models/winco/user.model';
import { BetterScore } from './models/winco/better-score.model';
import { EError } from './enums/error.enum';
import { ECameraFunction } from './enums/camera-function.enum';
import { EExerciseType } from './enums/type-exercise.enum';
import { ECirclePercentType } from './enums/circle-percent-type.enum';
import { LocalStorageService } from 'local-storage';

/**
 * Componente que represanta la base de la aplicación
 */
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent
{
  private readonly resizeMinSize: number = 8;
  private readonly resizeMaxSize: number = this.getHtmlBaseFontSize();

  TypeFooterEnum = ETypeFooter;
  ETypeUserEnum = ETypeUser;
  EViewerAsideEnum = EViewerAside;
  ECamera = ECamera;
  ECirclePercentType = ECirclePercentType;

  @ViewChildren(InfoBoxComponent) infoBox!: QueryList<InfoBoxComponent>;
  @ViewChild('exerciseDetail', {read: BestExerciseDetailComponent, static: false}) exerciseDetail: BestExerciseDetailComponent;
  @ViewChild('header', {read: ElementRef}) header: ElementRef;

  //configuración para el componente de ayuda
  helpViewer =
  [
    {
      name: 'infoMenu',
      class: 'info-menu',
      type: 'none'
    },
    {
      name: 'infoInstructions',
      class: 'info-instructions',
      type: 'none'
    },
    {
      name: 'infoVideo',
      class: 'info-video',
      type: 'info'
    },
    {
      name: 'infoPlayer',
      class: 'info-player',
      type: 'player'
    },
    {
      name: 'infoTimer',
      class: 'info-timer',
      type: 'player'
    }
  ];;

  //variables para el control de idiomas
  nameLanguage: string;
  showLanguages = false;
  activeLanguage: string;
  availableLanguages: Language[];

  //variables para el control de carga de páginas
  isInitPage: boolean;
  isMenuPage: boolean;
  isFlsPage: boolean;
  isExercisePage: boolean;

  hasHeader: boolean;

  hasMenuAdmin: boolean;
  hasMenuNav: boolean;
  hasFooter: boolean;
  hasMenuAction: boolean;
  typeFooter: ETypeFooter;
  showResultExerciseButtons:boolean;
  showExerciseDetail:boolean;

  userAcronym: string; //acrónimo de usuario
  userName: string; //nombre completo de usuario
  userRol: ETypeUser; //rol de usuario

  //variables para el control del componente Aside
  aside: EViewerAside;
  returnAside:EViewerAside;

  //variables para el control de reproducción
  hasVideoButton:boolean;
  // hasMultiCamera:boolean;
  // zoomPoster: string;
  // zoomVideo: string;

  //camara activa para la visualización en tiempo real
  // camera:ECamera;

  betterScore:number;
  betterTime:string;

  //variables para la composición de urls de navegación
  type:string;
  uuidExercise:string;
  uuidExerciseHistory: string | undefined;
  uuidCourse:string;
  uuidUser:string

  startedExercise = false; //indica si se está reproduciendo un ejercicio
  trackingActive: boolean = false;

  anno: number; //año actual

  menus:any;

  studentProgress = 0;


  constructor(private translateService:TranslateService,
              private languageService:LanguageService,
              private authService:AuthWincoService,
              private router:Router,
              private ipcService: IpcService,
              private electronService: ElectronService,
              private exerciseService: ExerciseService,
              private videoService: VideoService,
              private ref: ElementRef,
              private versionBoxService: VersionBoxService,
              private httpClientService: HttpClientService,
              private crudService:CrudManagerService,
              private dialogService: DialogBoxService,
              private eventManagerService: EventManagerService,
              public cameraService: CameraService,
              private storageService: LocalStorageService,
              private ngZone: NgZone,
              private cdr: ChangeDetectorRef)
  {
    //añadimos todos los eventos al eventManager
    this.eventManagerService.addEvent<WincoUser>(WincoEvents.ENABLE_USER);

    this.eventManagerService.addEvent<void>(WincoEvents.RESIZE_CAMERA);
    this.eventManagerService.addEvent<void>(WincoEvents.CONNECT_AUXILIAR_CAMERA);
    this.eventManagerService.addEvent<void>(WincoEvents.DISCONNECT_AUXILIAR_CAMERA);
    this.eventManagerService.addEvent<ECamera>(WincoEvents.CHANGE_CAMERA);

    this.eventManagerService.addEvent<EViewerAside>(WincoEvents.SET_ASIDE);
    this.eventManagerService.addEvent<EViewerAside>(WincoEvents.SET_BUTTONS);
    this.eventManagerService.addEvent<boolean>(WincoEvents.SHOW_VIDEO_BUTTON);
    this.eventManagerService.addEvent<BetterScore>(WincoEvents.ON_UPDATE_BETTER);
    this.eventManagerService.addEvent<any>(WincoEvents.SHOW_BEST_EXERCISE);
    this.eventManagerService.addEvent<void>(WincoEvents.HIDE_BEST_EXERCISE);
    this.eventManagerService.addEvent<string[]>(WincoEvents.CLOSE_EXERCISE);
    this.eventManagerService.addEvent<boolean>(WincoEvents.START_EXERCISE);
    this.eventManagerService.addEvent<boolean>(WincoEvents.TRACKING_CHECK);
    this.eventManagerService.addEvent<void>(WincoEvents.GET_BETTER_SCORE);
    this.eventManagerService.addEvent<void>(WincoEvents.SHOW_STUDENT_PROGRESS);
    this.eventManagerService.addEvent<any>(WincoEvents.SAVE_FILE);
    this.eventManagerService.addEvent<string>(WincoEvents.LANGUAGE_SOURCE);
    this.eventManagerService.addEvent<void>(WincoEvents.GET_EXERCISE_BY_UUID);
    this.eventManagerService.addEvent<void>(WincoEvents.STOP_VIDEO);
    this.eventManagerService.addEvent<any>(WincoEvents.IA_ANALIZED);


    this.menus =
    {
      administration: [
        { name: 'grupos', link: '/administration/groups/list', select: 'groups', permisions: [ETypeUser.ADMIN, ETypeUser.TEACHER], hidden: true, selected: false},
        { name: 'profesores', link: '/administration/teachers/list', select: 'teachers', permisions: [ETypeUser.ADMIN], hidden: true, selected: false},
        { name: 'alumnos', link: '/administration/students/list', select: 'students', permisions: [ETypeUser.ADMIN, ETypeUser.TEACHER], hidden: true, selected: false},
        { name: 'ejercicios', link: '/administration/exercises/list', select: 'exercises', permisions: [ETypeUser.ADMIN, ETypeUser.TEACHER], hidden: true, selected: false},
        { name: 'cursos', link: '/administration/courses/list', select: 'courses', permisions: [ETypeUser.ADMIN, ETypeUser.TEACHER], hidden: true, selected: false}
      ],
      general: [
        { name: 'administracion', icon: 'icon_list_white', link: '/administration/groups/list', select: 'administration', permisions: [ETypeUser.ADMIN, ETypeUser.TEACHER], hidden: true, selected: false},
        { name: 'mi_perfil', icon: 'icon_perfil_white', link: '/profile', select: 'profile', permisions: [ETypeUser.ADMIN, ETypeUser.TEACHER, ETypeUser.STUDENT], hidden: true, selected: false},
        { name: 'actualizar', icon: 'icon_update_white', link: '/update', select: 'update', permisions: [ETypeUser.ADMIN, ETypeUser.TEACHER, ETypeUser.STUDENT], hidden: true, selected: false},
        { name: 'exportar', icon: 'icon_export_white', link: '/export', select: 'export', permisions: [ETypeUser.ADMIN, ETypeUser.TEACHER, ETypeUser.STUDENT], hidden: true, selected: false},
        // { name: 'formacion_online', icon: 'icon_gride', link: '/online/rooms', select: 'online', permisions: [ETypeUser.ADMIN, ETypeUser.TEACHER], hidden: true, selected: false},
        { name: 'historico', icon: 'icon_history_1_white', link: '/history/history', select: 'history', permisions: [ETypeUser.ADMIN, ETypeUser.TEACHER, ETypeUser.STUDENT], hidden: true, selected: false},
        { name: 'estadisticas', icon: 'icon_graf_white', link: '/statistics', select: 'statistics', permisions: [ETypeUser.ADMIN, ETypeUser.TEACHER, ETypeUser.STUDENT], hidden: true, selected: false},
        { name: 'cursos', icon: 'icon_cursos_white', link: '/courses/list', select: 'courses', ignore: 'administration', permisions: [ETypeUser.ADMIN, ETypeUser.TEACHER, ETypeUser.STUDENT], hidden: true, selected: false},
        { name: 'entrenamiento', icon: 'icon_formas_black', activeIcon: 'icon_formas_white', restBackground: 'var(--winco-brand-white)', link: '/exercise/type', select: 'exercise', permisions: [ETypeUser.ADMIN, ETypeUser.TEACHER, ETypeUser.STUDENT], hidden: true, selected: false},
        { name: 'cerrar_sesion', icon: 'icon_logout_white', click: () => this.logOut(), hidden: true, selected: false}
      ],
      cameras: [
        { name: 'camara_principal', icon: 'cam_1_white', click: (parameter:ECamera) => this.changeCamera(parameter), parameter: ECamera.SYSTEM, select: 'exercise/viewer', hidden: true, selected: false},
        { name: 'camara_auxiliar', icon: 'cam_2_white', click: (parameter:ECamera) => this.changeCamera(parameter), parameter: ECamera.AUXILIAR, select: 'exercise/viewer', hidden: true, selected: false},
        { name: 'ambas_camaras', icon: 'cam_doble_white', click: (parameter:ECamera) => this.changeCamera(parameter), parameter: ECamera.BOTH, select: 'exercise/viewer', hidden: true, selected: false}
      ],
      aside: [
        { name: 'video_explicativo', icon: 'icon_video_white', click: (parameter:EViewerAside) => this.changeRightContent(parameter), parameter: EViewerAside.VIDEO, select: 'exercise/viewer', hidden: true, selected: false},
        // { name: 'zoom', icon: 'icon_zoom', click: (parameter:EViewerAside) => this.changeRightContent(parameter), parameter: EViewerAside.ZOOM, select: 'exercise/viewer', hidden: true, selected: false},
        { name: 'guia', icon: 'icon_bullets_white', click: (parameter:EViewerAside) => this.changeRightContent(parameter), parameter: EViewerAside.GUIDE, select: 'exercise/viewer', hidden: true, selected: false},
        // { name: 'chat', icon: 'icon_chat', click: (parameter:EViewerAside) => this.changeRightContent(parameter), parameter: EViewerAside.CHAT, select: 'exercise/viewer', hidden: true, selected: false},
        { name: 'ayuda', icon: 'icon_help_white', click: (parameter:EViewerAside) => this.changeRightContent(parameter), parameter: EViewerAside.HELP, select: 'exercise/viewer', hidden: true, selected: false},
        { name: 'cerrar_sesion', icon: 'icon_logout_white', click: () => this.logOut(), select: 'exercise/viewer', hidden: true, selected: false}
      ],
      separator: { select: 'exercise/viewer', hidden: true }
    };


    //gestión de carga de páginas
    //controla la visualización de los distintos elementos que
    //componen un pantalla en función de la url que deba ser cargada
    this.router.events.subscribe((routerData) =>
    {
      if(routerData instanceof ResolveEnd)
      {
        this.ngZone.run(() =>
        {
          this.isInitPage = false;
          this.isMenuPage = false;
          this.isExercisePage = false;
          this.isFlsPage = false;
          this.hasMenuAdmin = false;
          this.hasMenuNav = false;
          this.hasMenuAction = false;
          this.hasFooter = false;
          this.typeFooter = ETypeFooter.CLEAR;
          this.showResultExerciseButtons = false;
          this.hasHeader = true;

          this.videoService.stopVideo();

          if(routerData.url.indexOf('account') >= 0)
          {
            this.hasFooter = true;
            this.typeFooter = ETypeFooter.AUTH;
          }
          else if(routerData.url.indexOf('administration') >= 0)
          {

            // if(routerData.url.indexOf('list') >= 0)
            //   this.exerciseService.ClearForms('list');
            // else if(routerData.url.indexOf('edit') >= 0)
            //   this.exerciseService.ClearForms('edit');
            // else
            this.exerciseService.ClearForms();

            this.isMenuPage = true;
            this.hasMenuAdmin = true;
            this.hasMenuNav = true;

            if(routerData.url.indexOf('edit') >= 0)
            {
              this.hasFooter = false;
              this.typeFooter = ETypeFooter.CLEAR;
            }
            else
            {
              this.hasFooter = true;
              this.typeFooter = ETypeFooter.LINE;
            }
          }
          else if(routerData.url.indexOf('profile') >= 0)
          {
            this.isMenuPage = true;
            this.hasMenuNav = true;
            this.hasFooter = false;
            this.typeFooter = ETypeFooter.CLEAR;
          }
          else if(routerData.url.indexOf('exercise') >= 0)
          {
            if(routerData.url.indexOf('viewer') >= 0)
              this.exerciseService.ClearExercise('viewer');
            else if(routerData.url.indexOf('statistics') >= 0)
              this.exerciseService.ClearExercise('statistics');
            else
              this.exerciseService.ClearExercise();

            this.isMenuPage = true;
            this.hasFooter = (routerData.url.indexOf('checklist') < 0);
            this.typeFooter = ETypeFooter.LINE;

            if(routerData.url.indexOf('viewer') >= 0)
            {
              this.isExercisePage = true;
              this.hasMenuAction = true;
              this.hasMenuNav = false;
              this.hasHeader = false;
            }
            else
            {
              this.hasMenuAction = false;
              this.hasMenuNav = true;
            }

            if(routerData.url.indexOf('results') >= 0)
            {
              this.isExercisePage = true;
              this.showResultExerciseButtons = true;
            }

            if(routerData.url.indexOf('list/' + EExerciseType.FLS) >= 0 && authService.getUser())
            {
              this.isFlsPage = true;
              this.eventManagerService.emitEvent(WincoEvents.SHOW_STUDENT_PROGRESS);
            }
          }
          else if(routerData.url.indexOf('statistics') >= 0 ||
                  routerData.url.indexOf('export') >= 0 ||
                  routerData.url.indexOf('update') >= 0 ||
                  routerData.url.indexOf('history') >= 0 ||
                  routerData.url.indexOf('courses') >= 0 ||
                  routerData.url.indexOf('online') >= 0)
          {
            this.isMenuPage = true;
            this.hasMenuNav = true;
            this.hasFooter = (routerData.url.indexOf('statistics') < 0);
            this.typeFooter = ETypeFooter.LINE;
          }
          else if(routerData.url.indexOf('errors') >= 0)
          {
            this.isMenuPage = false;
            this.hasMenuNav = false;
            this.hasFooter = false;
            this.isExercisePage = false;
            this.isFlsPage = false;
            this.hasMenuAction = false;
          }
          else
          {
            this.isInitPage = true;
          }

          for (const key in this.menus)
            this.checkMenu(key, routerData.url);
        });
      }
    });


    //informa de si el componente ViewerAside se está mostrando o no
    this.eventManagerService.subscribeEvent<EViewerAside>(WincoEvents.SET_BUTTONS, (data:EViewerAside) =>
    {
      setTimeout(() =>
      {
        if(data == EViewerAside.CLOSE_HELP)
        {
          this.aside = this.returnAside;
        }
        else
        {
          if(data != EViewerAside.HELP)
            this.returnAside = data;

          this.aside = data;
        }

        this.checkMenu('aside', this.router.url);
        this.checkMenu('cameras', this.router.url);
      },
      0);
    });

    //informa de si el deben mostrarse los botones de control de vídeo o no
    this.eventManagerService.subscribeEvent<boolean>(WincoEvents.SHOW_VIDEO_BUTTON, (show:boolean) =>
    {
      this.hasVideoButton = show;
      this.returnAside = (show) ? EViewerAside.VIDEO : EViewerAside.GUIDE;
    });

    this.eventManagerService.subscribeEvent<ECamera>(WincoEvents.CHANGE_CAMERA, () => this.checkMenu('cameras', this.router.url));

    this.eventManagerService.subscribeEvent<ECamera>(WincoEvents.CONNECT_AUXILIAR_CAMERA, () => this.checkMenu('cameras', this.router.url));

    this.eventManagerService.subscribeEvent<ECamera>(WincoEvents.DISCONNECT_AUXILIAR_CAMERA, () => this.checkMenu('cameras', this.router.url));

    //informa de si debe mostrarse el porcentaje de mejor puntuación cuando hay o no tracking
    this.eventManagerService.subscribeEvent<boolean>(WincoEvents.TRACKING_CHECK, (show:boolean) => setTimeout(() => this.trackingActive = show, 250));


    //actualiza los valores que se muestran en el pie (betterScore y betterTime)
    //actualiza los uuid de todos los valores necesarios para crear las url de retorno
    this.eventManagerService.subscribeEvent<BetterScore>(WincoEvents.ON_UPDATE_BETTER, (data:BetterScore) =>
    {
        this.betterScore = data.score;
        this.betterTime = this.exerciseService.GetFormatTime(data.time);
        this.uuidExercise = data.uuidExercise;
        this.uuidExerciseHistory = data.uuidExerciseHistory;
        this.uuidCourse = data.uuidCourse;
        this.uuidUser = data.uuidUser;
        this.type = data.type;
    });

    //actualiza los datos que se muestran del usuario
    this.eventManagerService.subscribeEvent<WincoUser>(WincoEvents.ENABLE_USER, (user:WincoUser) =>
    {
      this.userAcronym = (user.name[0] + user.surname[0]).toUpperCase();
      this.userName = user.name + ' ' + user.surname;
      this.userRol = user.idType;
    });

    //actualiza los datos de la vista de detalle de un ejercicio
    //y muestra el componente ExerciseDetail
    this.eventManagerService.subscribeEvent<any>(WincoEvents.SHOW_BEST_EXERCISE, (data:any) =>
    {
      this.showExerciseDetail = true;

      setTimeout(() =>
      {
        this.exerciseDetail.time = data.time;
        this.exerciseDetail.score = data.score;
        this.exerciseDetail.userName = data.userName;
        this.exerciseDetail.urlPoster = data.urlPoster;
        this.exerciseDetail.urlVideo = data.urlVideo;
        this.exerciseDetail.params = data.params;
      }, environment.delayOperation);
    });

    //limpia los datos de la vista de detalle de un ejercicio
    //y oculta el componente ExerciseDetail
    this.eventManagerService.subscribeEvent<void>(WincoEvents.HIDE_BEST_EXERCISE, () =>
    {
      this.showExerciseDetail = false;

      this.exerciseDetail.time = null;
      this.exerciseDetail.score = null;
      this.exerciseDetail.userName = null;
      this.exerciseDetail.urlPoster = null;
      this.exerciseDetail.urlVideo = null;
      this.exerciseDetail.params = null;
    });

    //notificación de que se ha comenzado a realizar un ejercicio
    this.eventManagerService.subscribeEvent<boolean>(WincoEvents.START_EXERCISE, (status:boolean) => this.startedExercise = status);

    this.eventManagerService.subscribeEvent<void>(WincoEvents.SHOW_STUDENT_PROGRESS, () =>
      this.exerciseService.getProgressStudent().then(progress => this.studentProgress = progress));

    this.anno = new Date().getFullYear();

    this.httpClientService.initialize();

    this.storageService.initialize().then(() =>
      this.crudService.init(this.httpClientService));

    //carga el idioma por defecto
    this.activeLanguage = this.languageService.getLanguage() ?? environment.defaultLanguage;

    this.translateService.setDefaultLang(environment.defaultLanguage);
    this.languageService.setLanguage(this.activeLanguage);
    this.translateService.use(this.activeLanguage);

    this.languageService.getAvailableLanguages().subscribe(response =>
    {
      this.availableLanguages = response;

      const language = this.availableLanguages.find(x => x.code === this.activeLanguage);

      language.enabled = false;
      this.nameLanguage = language.code.toUpperCase();

      this.ipcService.initializeData().then(() =>
      {
        this.versionBoxService.initialize(this.ipcService.info.software, this.ipcService.info.hardware);

        //obtenemos los datos del usuario
        const user = this.authService.getUser();

        //si existe usuario actualizamos los datos de visualización
        if(user)
        {
          this.userAcronym = (user.name[0] + user.surname[0]).toUpperCase();
          this.userName = user.name + ' ' + user.surname;
          this.userRol = user.idType;
        }

        this.cameraService.initialize().then(() =>
        {
          this.cameraService.checkCameras().then(() =>
          {
            this.cameraService.setCameraViewer().then(() =>
            {
              this.cameraService.setCameraTracking().then(() =>
              {
                this.clearUser();

                // this.authService.CheckInit().then(msg =>
                  // this.router.navigate(['/', 'account', (msg.message === "1") ? 'login' : 'new-account']));

                this.router.navigate(['/', 'intro']);
              })
              .catch(err =>
              {
                console.error('[AppComponent] Camera tracking initialization failed.', err);
                this.router.navigate(['/', 'errors', 'error', EError.TRACKING_FAILED]);
              });
            })
            .catch(err =>
            {
              console.error('[AppComponent] Camera viewer initialization failed.', err);
              this.router.navigate(['/', 'errors', 'error', EError.VIEWER_FAILED]);
            });
          })
          .catch(err =>
          {
            console.error('[AppComponent] Camera availability check failed.', err);
            this.router.navigate([ '/', 'errors' , 'error', (!err) ? EError.CAMERAS_NOT_FOUND : (err === ECameraFunction.TRACKING) ? EError.TRACKING_FAILED : EError.VIEWER_FAILED ]);
          });
        })
        .catch(err =>
        {
          console.error('[AppComponent] Camera service initialization failed.', err);
          this.router.navigate([ '/', 'errors' , 'error', EError.CAMERAS_NOT_FOUND ]);
        });
      })
      .catch(() => this.router.navigate([ '/', 'errors', 'error', EError.REQUEST_ERROR ]));
    });
  }

  checkMenu(key:string, url:string)
  {
    if(key !== 'separator')
    {
      this.menus[key].map(menu =>
      {
        switch(key)
        {
          case 'administration' : case 'general' :
            menu.hidden = !this.hasPermissions(menu.permisions);
            menu.selected = (!!menu.select) ? this.getMenuSelected(url, menu.select, menu.ignore ?? '') : false;
            break;
          case 'cameras' :
            menu.hidden = !(this.getMenuSelected(url, menu.select) && this.cameraService.hasMultiCamera);
            menu.selected = (this.cameraService.camera === menu.parameter);
            break;
          case 'aside' :
            menu.hidden = !(this.getMenuSelected(url, menu.select) && ((menu.parameter === EViewerAside.VIDEO) ? this.hasVideoButton : true));
            menu.selected = (menu.parameter != null) ? (this.aside === menu.parameter) : false;
            break;
        }
      });

      if(key === 'cameras')
        this.menus.separator.hidden = !(this.getMenuSelected(url, this.menus.separator.select) && this.cameraService.hasMultiCamera);

      this.cdr.detectChanges();
    }
  }


  /**
   * Se ejecuta la primera vez que se carga la página
   */
  ngOnInit(): void
  {
    this.onResize();
  }

  @HostListener('window:beforeunload')
  async onBeforeUnload()
  {
    this.clearUser();
    await this.cameraService.finalizeAnalysis();
  }

/**
 * Redimensiona el tamaño de fuente en función del tamaño de la ventana
 * permitiendo que los estilos css basados en medidas relativas (em, rem)
 * se auto-ajusten según cambia el tamaño de la ventana
 */
  @HostListener('window:resize')
  onResize() {
    const minWidth = 480,
          minHeight = 320;

    let windowWidth:number = window.innerWidth,
        windowHeight:number = window.innerHeight,
        width:number,
        height:number,
        size:number;

    if(windowWidth < minWidth) windowWidth = minWidth;
    if(windowHeight < minHeight) windowHeight = minHeight;

    if(windowWidth > windowHeight)
    {
      width = windowWidth;
      height = windowWidth * minHeight / minWidth;

      if(height > windowHeight)
      {
        height = windowHeight;
        width = windowHeight * minWidth / minHeight;
      }
    }
    else
    {
      height = windowHeight;
      width = windowHeight * minWidth / minHeight;

      if(width > windowWidth)
      {
        width = windowWidth;
        height = windowWidth * minHeight / minWidth;
      }
    }

    size = Math.round(height * this.resizeMinSize / minHeight);

    if(size > this.resizeMaxSize) size = this.resizeMaxSize;

    this.ref.nativeElement.style.fontSize = size + 'px';
  }

  private getHtmlBaseFontSize(): number
  {
    const fallbackSize = 24;

    if(typeof window === 'undefined' || typeof document === 'undefined')
      return fallbackSize;

    const htmlFontSize = Number.parseFloat(window.getComputedStyle(document.documentElement).fontSize);

    return (Number.isFinite(htmlFontSize)) ? htmlFontSize : fallbackSize;
  }


  /**
  * Muestra u oculta la lista de idiomas disponibles
  * @param e Event
  */
  toggleLanguages(e:Event)
  {
    e.preventDefault();
    this.showLanguages = (!this.showLanguages && this.availableLanguages.filter(x => x.enabled).length > 0);
  }

  /**
   * Establece un idioma seleccionado desde la lista de idiomas
   * @param e Event
   * @param language Código de idioma ISO
   */
  selectLanguage(e:Event, language:string)
  {
    e.preventDefault();

    this.activeLanguage = language;
    this.languageService.setLanguage(language);
    this.translateService.use(language);

    this.availableLanguages?.map((item) => { item.enabled = true; });

    const lang = this.availableLanguages?.find(x => x.code === this.activeLanguage);

    lang.enabled = false;
    this.nameLanguage = lang.code.toUpperCase();

    this.showLanguages = false;
  }

  /**
   * Comprueba si la opción del menú lateral está seleccionada actualmente
   * @param elem Nombre de la página
   * @param ignore Indica si algún componente de la url debe ser ignorado
   * @returns Boolean
   */
  getMenuSelected(url:string, elem:string, ignore:string = '') : boolean
  {
    if(ignore && url.indexOf(ignore) >= 0)
      return false;

    return url.indexOf(elem) >= 0;
  }

  /**
   * Comprueba si un usuario tiene permiso para ver un apartado del menú
   * @param roles Lista de roles permitidos para el apartado
   * @returns Boolean
   */
  hasPermissions(roles:ETypeUser[])
  {
    return (roles) ? (roles.indexOf(this.userRol) >= 0) : true;
  }

  /**
   * Cambia el contenido del componente ViewerAside del lateral derecho de la pantalla
   * @param aside EViewerAside - Tipo de aside
   */
  changeRightContent(aside:EViewerAside)
  {
    this.eventManagerService.emitEvent(WincoEvents.SET_ASIDE, aside);
  }

  /**
   * Cambia la vista de un slider de la pantalla de ayuda
   * @param ev CustomEvent
   */
  changeViewSlider(ev: any)
  {
    this.infoBox.map((info: InfoBoxComponent) => info.isOpen = (ev.detail == info.name) ? !info.isOpen : false);
  }

  /**
   * Cambia la vista de la cámara cuando la cámara auxiliar está conectada
   * @param camera ECamera - Cámara seleccionada
   */
  changeCamera(camera: ECamera)
  {
    if(this.cameraService.camera != camera || camera === ECamera.BOTH)
    {
      this.cameraService.camera = camera;
      this.cameraService.changeCamera(camera);
    }
  }

  /**
   * Recarga la pantalla de un ejercicio que el usuario ha terminado y desea repetir
   */
  repeatExercise()
  {
    this.router.navigate(['/', 'exercise', 'viewer', this.uuidExercise, this.type, this.uuidCourse, this.uuidExerciseHistory, this.uuidUser]);
  }

  /**
   * Cierra la ventana de detalle de un ejercicio
   */
  closeExerciseDetail()
  {
    this.showExerciseDetail = false;
  }

  /**
   * Fuerza el cierre de un ejercicio que aún está en proceso
   */
  goOut()
  {
    let route = [];

    switch(this.type)
    {
      case 'course' : route = [ '/', 'courses', 'detail', this.uuidCourse ]; break;
      case 'history' : route = [ '/', 'history', 'history', this.uuidExerciseHistory, this.uuidUser, this.uuidCourse ]; break;
      default: route = [ '/', 'exercise', 'type' ];
    }

    if(this.startedExercise)
      this.eventManagerService.emitEvent(WincoEvents.CLOSE_EXERCISE, route);
    else
      this.router.navigate(route);

    this.uuidUser = '';
    this.uuidExercise = '';
    this.uuidExerciseHistory = '';
    this.uuidCourse = '';
    this.type = '';
  }

  /**
   * Cierra la sesión del usuario actual
   */
  logOut(){
    this.dialogService.show(new DialogBoxData({
      type: DialogBoxType.CONFIRM,
      message: 'seguro_cerrar_sesion',
      acceptCallback: () =>
      {
        this.clearUser();
        this.router.navigate([ '/', 'account', 'login' ]);
      }
    }));
  }

  /**
   * Elimina los datos del usuario actual
   */
  clearUser()
  {
    this.authService.removeUser();
    this.userAcronym = '';
    this.userName = '';
    this.userRol = null;
  }

  /**
   * Cierra el programa
   */
  exit()
  {
    if(this.electronService.isElectronApp)
    {
      this.dialogService.show(new DialogBoxData({
        type: DialogBoxType.CONFIRM,
        message: 'seguro_salir',
        acceptCallback: () =>
        {
          this.clearUser();
          this.cameraService.finalizeAnalysis().then();
          this.ipcService.quitApp();
        }
      }));
    }
  }

  /**
   * Muestra una pantalla con la versión del software actual
   */
  showInfoVersion()
  {
    this.versionBoxService.show()
  }
}
